import { render, staticRenderFns } from "./createBlogs.vue?vue&type=template&id=12233cf7&scoped=true"
import script from "./createBlogs.vue?vue&type=script&lang=js"
export * from "./createBlogs.vue?vue&type=script&lang=js"
import style0 from "./createBlogs.vue?vue&type=style&index=0&id=12233cf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12233cf7",
  null
  
)

export default component.exports